import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import { CreateButton } from "./ui/buttons";
import ExerciseService from "../../../services/ExerciseService";
import { ExerciseViewModel } from "../../../viewModels";
import ExercisesTable from "./ui/ExercisesTable";
import ExercisesTableSkeleton from "./skeletons/ExercisesTableSkeleton";
export default function ExercisesPage() {
  const [searchParams] = useSearchParams();
  const api = new ExerciseService();
  const [items, setItems] = useState<ExerciseViewModel[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [searchParams.get("reload")]);

  const fetchData = async () => {
    const data = await api.getExercises()   
    setItems(data);
    setLoading(false);
  };

  return (
    <div className="w-full">
      <Breadcrumbs
        breadcrumbs={[{ label: "Exercises", href: "/admin/exercises" }]}
      />

      <CreateButton />
      {loading ? <ExercisesTableSkeleton /> : <ExercisesTable items={items} />}
    </div>
  );
}
